<template>
    <v-container grid-list-xs>
        <v-layout justify-center> 
            <v-flex xs6>
                <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                    v-model="customer.code"  
                    :disabled="this.$store.getters.get_edit_mode == '1'"
                    :rules="codeRules"
                    :counter="10"
                    label="Code"
                    readonly
                    required
                ></v-text-field>
                <v-text-field
                    v-model="customer.name"
                    :rules="nameRules"                    
                    label="Name" />
                <v-text-field
                    v-model="customer.email"                 
                    label="Email" />    
                <v-text-field
                    v-model="customer.password"                   
                    label="Password" />
                <v-text-field
                    v-model="customer.tel"
                    label="tel" />     
                <h3>Work Address</h3>    
                <v-text-field
                    v-model="customer.address1"
                    label="Address1" />
                <v-text-field
                    v-model="customer.address2"
                    label="Address2" />
                 <v-text-field
                    v-model="customer.zipcode"
                    label="zipcode"  />          
                <v-text-field
                    v-model="customer.latitude"
                    type = "number"
                    label="latitude"/>
                <v-text-field
                    v-model="customer.longitude"
                    type = "number"                    
                    label="longitude"/>              
                <h3>Home Address</h3>    
                <v-text-field
                    v-model="customer.h_address1"
                    label="Address1"  />
                <v-text-field
                    v-model="customer.h_address2"
                    label="Address2"  />
                 <v-text-field
                    v-model="customer.h_zipcode"
                    label="zipcode"  />          
                <v-text-field
                    v-model="customer.h_latitude"
                    type = "number"
                    label="latitude"/>
                <v-text-field
                    v-model="customer.h_longitude"
                    type = "number"                    
                    label="longitude"/>       
                <h3>Other Information</h3>       
                <v-text-field
                    v-model="customer.Allergies"
                    label="Allergies"/>     
                <v-text-field
                    v-model="customer.remark"
                    label="Remark"/>  
                <v-btn class="font-weight-light" tile :disabled="!valid"
                    @click="submit">
                    submit
                </v-btn>
                <v-btn class="font-weight-light" tile color="black" dark   
                :disabled="this.$store.getters.get_edit_mode == '1'"
                @click.native="clear">clear</v-btn>
                </v-form>
            </v-flex>
        </v-layout>   
    </v-container>

</template>

<script>
export default {
  data() {
    return {
        valid: true,
        customer:{
            code: '',
            name: '',
            email:'',
            password:'',
            address1:'',
            address2:'',
            zipcode:'',
            tel:'',
            Allergies:'',
            remark:'',
            latitude:'',
            longitude:'',
            h_address1:'',
            h_address2:'',
            h_zipcode:'',
            h_latitude:'',
            h_longitude:'',
        },    
        codeRules: [
          v => !!v || 'This field is required',
        ],
        nameRules: [
          v => !!v || 'This field is required',
        ],        
        passRules: [
          v => !!v || 'Password is required',
          v => (v && v.length >= 6) || 'This field must be more than 6 characters'
        ],
        otherRules: [
          v => !!v || 'This field is required',
        ],

    }
  },
    created () {
        if ( this.$store.getters.get_edit_mode == '0'){
            this.get_user_code()
        }
        if ( this.$store.getters.get_edit_mode == '1'){
            this.edit_data ()
        }
    },
  methods: {
    submit () {
        if (this.$refs.form.validate()) {
            if ( this.$store.getters.get_edit_mode == '0'){
                this.add_customer(this.customer.code)
            }
            if ( this.$store.getters.get_edit_mode == '1'){                
                this.edit_customer()
            }
            
        }
      },
    clear () {
        this.$refs.form.reset()
        this.get_user_code()
      },
    edit_data() {
        const vm = this;
        vm.axios.get('https://ws.plantifulbkk.shop/get_customer_edit.php',{
            params: {
                scode: this.$store.getters.get_user_code ,
            }
        }).then(response => {
        this.customer = JSON.parse(JSON.stringify(response.data))
        console.log(result)
        });
      },
    get_user_code() {
        const vm = this;
        vm.axios.get('https://ws.plantifulbkk.shop/get_new_user_code.php',{
            params: {
                scode: ''
            }
        }).then(response => {
            this.customer.code = response.data
            console.log(result)
        });
      },
      edit_customer(){
            const vm = this;
            vm.axios.get("https://ws.plantifulbkk.shop/post_edit_customer.php",{
                    params: {
                        scode: this.customer ,
                    }
                }).then(result=>{
                        console.log(result.data)
                        this.$refs.form.reset()
                        alert("Edit Customer Complete")
                        this.$router.push('/customer')
                    })
                .catch(function (error) {
                        alert("Error : Cannot Edit customer !!")
                        console.log(error)
            })

      },
      add_customer( datajson){

        const vm = this;
        vm.axios.get('https://ws.plantifulbkk.shop/get_chk_customer_code.php',{
            params: {
                scode: this.customer.code ,
            }
        }).then(response => {

            if ( response.data == 'code_is_correct'  ){

                vm.axios.get("https://ws.plantifulbkk.shop/post_add_customer.php",{
                    params: {
                        scode: this.customer ,
                    }
                }).then(result=>{
                        console.log(result.data)
                        this.$refs.form.reset()
                        alert("Add new Customer Complete")
                    })
                .catch(function (error) {
                        alert("Error : Cannot Add new customer !!")
                        console.log(error)
                    })

            }else{
                alert("Customer code Duplicate or not correct !!")
            }
        });
      }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/add_customer.vue